import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';

import styles from './legend-events.module.css';

const HotelEventsLegendEvents = <template>
  <div
    class="flex items-center justify-end gap-200"
    data-test-id="events-legend"
  >
    <div class="flex items-center gap-100">
      <span class="{{styles.swatch}} {{styles.confirmed}}"></span>
      <span class="text-200--medium">{{t "general.confirmed"}}</span>
    </div>
    <div class="flex items-center gap-100">
      <span class="{{styles.swatch}} {{styles.unconfirmed}}"></span>
      <span class="text-200--medium">{{t "general.unconfirmed"}}</span>
      <GeneralIconWithTooltip
        @tooltipContent={{t "events.legend.unconfirmed_tooltip"}}
      />
    </div>
  </div>
</template> satisfies TOC<Record<string, never>>;

export default HotelEventsLegendEvents;
